import flatten from 'flat';
import app from './fr-FR/app';
import dashboard from './fr-FR/dashboard';
import date from './fr-FR/date';
import dpu from './fr-FR/dpu';
import menu from './fr-FR/menu';
import navBar from './fr-FR/navBar';
import tableContentView from './fr-FR/tableContentView';
import trigger from './fr-FR/trigger';
import promoBanner from './fr-FR/promoBanner';
import workspace from './fr-FR/workspace';
import emojiPicker from './fr-FR/emojiPicker';

export default flatten({
  ...app,
  ...dashboard,
  ...date,
  ...dpu,
  ...menu,
  ...navBar,
  ...tableContentView,
  ...trigger,
  ...promoBanner,
  ...workspace,
  ...emojiPicker,
});
